const sendMessageToParent = (data: any) => {
	window.parent.postMessage(data, "*");
};
const listenForMessage = () => {
	window.addEventListener("message", (ev) => {
		// eslint-disable-next-line no-console
		console.log("message received", ev);
	});
};
//const onLocaleChange = (handler: (newLocale:string)=>void)=>void;
export { sendMessageToParent, listenForMessage };
